import { FC, memo } from 'react'

import { BreadcrumbSkeletonContainer, SkeletonBreadcrumb, SkeletonSeparator } from './styles'

interface Props {
    containerPadding?: string
}

const BreadcrumbSkeleton: FC<Props> = ({ containerPadding }) => {
    return (
        <BreadcrumbSkeletonContainer containerPadding={containerPadding}>
            <SkeletonBreadcrumb $width="3.5rem" />
            <SkeletonSeparator />
            <SkeletonBreadcrumb $width="6.5rem" />
            <SkeletonSeparator />
            <SkeletonBreadcrumb $width="2rem" />
            <SkeletonSeparator />
            <SkeletonBreadcrumb $width="4rem" />
        </BreadcrumbSkeletonContainer>
    )
}

export default memo(BreadcrumbSkeleton)
